import { render } from "./rolesIndex.vue?vue&type=template&id=3fb9edae&scoped=true"
import script from "./rolesIndex.vue?vue&type=script&lang=js"
export * from "./rolesIndex.vue?vue&type=script&lang=js"

import "./rolesIndex.vue?vue&type=style&index=0&id=3fb9edae&lang=less&scoped=true"
import "./rolesIndex.vue?vue&type=style&index=1&id=3fb9edae&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb9edae"]])

export default __exports__